import { Link, makeStyles } from "@material-ui/core";
import { bodyTextSize, useCardStyles } from "../../lib/constants";

const useStyles = makeStyles(() => ({
  dynamicTextContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    paddingTop: 5
  },
  dynamicTextFadeOut: {
    display: "flex",
    flexGrow: 1,
    width: "100%",
    overflow: "hidden",
    maskImage: "linear-gradient(to bottom, black 65%, transparent 100%)"
  },
  dynmaicTextTypography: {
    display: "flex",
    fontFamily: "Roboto",
    fontWeight: 400,
    lineHeight: 1.43,
    letterSpacing: "0.01071em",
    fontSize: bodyTextSize,
    color: "rgba(0, 0, 0, 0.54)"
  },
  dynamicTextLink: {
    display: "flex",
    marginBottom: 16,
    fontSize: "1em"
  }
}));

export function DynamicText(props) {
  const { children, style, onReadMoreClick } = props;
  const classes = useStyles();
  const cardClasses = useCardStyles();
  return (
    <div className={classes.dynamicTextContainer} style={style}>
      <div className={classes.dynamicTextFadeOut}>
        <div className={classes.dynmaicTextTypography}>{children}</div>
      </div>
      <Link
        onClick={onReadMoreClick}
        variant="body2"
        classes={{ root: cardClasses.linkStyling }}
        className={classes.dynamicTextLink}
      >
        Mehr lesen
      </Link>
    </div>
  );
}
